import React from 'react';
import { PageType } from '@hotelplan/graphql.types';
import { Container } from 'components/core/container';
import { IPdpPageProps, PdpTabsKey } from 'components/domain/pdp/Pdp.types';
import PdpPageLayout from 'components/domain/pdp/PdpPageLayout';
import { usePdpTabs } from 'components/domain/pdp/usePdpTabs';
import { createPageServerFn } from 'config';
import { pdpHistoryUnit } from 'config/pdp/pdpHistoryUnit';
import { serverPdpContentUnit } from 'config/pdp/serverPdpContentUnit';
import { serverPdpCorrectUrlUnit } from 'config/pdp/serverPdpCorrectUrlUnit';

export default function PdpItineraryPage({
  content,
  isRoundtrip,
}: IPdpPageProps): React.ReactElement {
  const { tabItems, getComponentByTab } = usePdpTabs(content, isRoundtrip);

  return (
    <Container>
      <PdpPageLayout
        tabItems={tabItems}
        tabKey={PdpTabsKey.Itinerary}
        {...content?.content.overview}
        {...content?.content.description}
      >
        {getComponentByTab(PdpTabsKey.Itinerary)}
      </PdpPageLayout>
    </Container>
  );
}

export const getServerSideProps = createPageServerFn(
  {
    namespaceRequired: ['pdp', 'orl'],
    pageEventType: 'pdp', // todo: supply proper `pageEventType`
    pageType: PageType.PdpItinerary,
  },
  [
    pdpHistoryUnit,
    serverPdpCorrectUrlUnit,
    serverPdpContentUnit({ ref: 'pdp-itinerary-ref' }),
  ]
);
